import { Box, Loader, Transition } from '@wix/design-system';
import { RulesPanelUIProvider } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai';
import React, { useRef } from 'react';
import { scrollerNodeRefAtom } from '../../atoms/session-atoms';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useVerticalDrillInScreen } from './use-vertical-drill-in-screen';
import { VerticalsDrillInContent } from './verticals-drill-in-content';
import { VerticalsDrillInStandaloneScreen } from './verticals-drill-in-standalone-screen';
import { VerticalsDrillInTopSection } from './verticals-drill-in-top-section';
export const VerticalsDrillInScreen = () => {
  const divRef = useRef(null);
  const {
    executionResults,
    jotaiStore,
    unsavedChangedHandlersProps,
    toggleFunctions
  } = useVerticalDrillInScreen();
  const setScrollerNode = useSetAtom(scrollerNodeRefAtom);
  setScrollerNode(divRef);
  const {
    capabilities
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  if (executionResults === undefined || Object.keys(executionResults).length === 0) {
    // todo: change with real loading screen
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Transition, {
    animateOnLoad: true,
    enterAnimation: {
      moveIn: {
        direction: 'rightToLeft',
        distance: '300px',
        duration: 'fast01',
        easing: 'enterEasing'
      }
    }
  }, /*#__PURE__*/React.createElement(RulesPanelUIProvider, {
    store: jotaiStore,
    unsavedChangesHandlers: unsavedChangedHandlersProps,
    onToggleFunctions: toggleFunctions
  }, compactPanelChrome ? /*#__PURE__*/React.createElement(VerticalsDrillInStandaloneScreen, null) : /*#__PURE__*/React.createElement(Box, {
    bottom: "0",
    direction: "vertical",
    height: "100%",
    left: "0",
    position: "absolute",
    right: "0",
    top: "0"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "D80",
    flex: "0 0 auto",
    position: "sticky",
    top: "0",
    width: "100%",
    zIndex: 10
  }, /*#__PURE__*/React.createElement(VerticalsDrillInTopSection, null)), /*#__PURE__*/React.createElement("div", {
    ref: divRef,
    style: {
      flex: '1 1 auto',
      minHeight: '280px',
      overflowX: 'hidden',
      overflowY: 'auto',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(VerticalsDrillInContent, null)))));
};
//# sourceMappingURL=verticals-drill-in-screen.js.map